export default __webpack_public_path__ + "static/media/title_guide.bf341ba9.svg";